<p-tabMenu [model]="items"></p-tabMenu>
<ng-container *ngIf="activeItemId == 1">
    <app-sales-report-first-tab></app-sales-report-first-tab>
</ng-container>
<ng-container *ngIf="activeItemId == 2">
    <app-sales-report-second-tab></app-sales-report-second-tab>
</ng-container>
<ng-container *ngIf="activeItemId == 3">
    <app-sales-report-third-tab></app-sales-report-third-tab>
</ng-container>
<ng-container *ngIf="activeItemId == 4">
    <app-sales-report-highschool></app-sales-report-highschool>
</ng-container>
<ng-container *ngIf="activeItemId == 5">
    <app-sales-report-english-market></app-sales-report-english-market>
</ng-container>
<ng-container *ngIf="activeItemId == 6">
    <app-sales-report-all-agents></app-sales-report-all-agents>
</ng-container>